var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 514,
    viewBox: "0 0 1440 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.975 1L-453.307 647M555.918 1L-143.793 647M577.863 1L57.1464 647M599.808 1L205.239 647M621.751 1L324.063 647M643.695 1L425.433 647M665.64 1L516.052 647M687.584 1L600.161 647M709.528 1L680.757 647M731.471 1L760.242 647M753.416 1L840.839 647M775.36 1L924.948 647M797.304 1L1015.57 647M819.248 1L1116.94 647M841.191 1L1235.76 647M863.136 1L1383.85 647M885.08 1L1584.79 647M907.026 1L1894.31 647M-821.71 554.714H2262.71M-599.419 462.429H2040.42M-377.129 370.143H1818.13M-154.84 277.857H1595.84M67.4507 185.571H1373.55M289.741 93.2856H1151.26M512.032 1L-1044 647H2485L928.968 1H512.032Z",
    stroke: "url(#paint0_linear_190_1148)",
    strokeWidth: 0.17013
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_1148",
    x1: 721,
    y1: 647,
    x2: 721,
    y2: 0.999993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E69FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/Lines.c9f526e73c0be6b5a5ddf5ed8bdc4670.svg";
export { ForwardRef as ReactComponent };